import { useCallback, useEffect, useState } from "react";
import { teslaApi } from "../../../Services/teslaApi";
import { BessProfile } from "../types";

// O catálogo é estático por versão do backend; guardar em módulo evita refazer a
// chamada a cada vez que a seção de bateria é montada.
let cache: BessProfile[] | null = null;

export interface UseBessProfiles {
  profiles: BessProfile[];
  loading: boolean;
  error: string | null;
  retry: () => void;
}

export function useBessProfiles(enabled: boolean): UseBessProfiles {
  const [profiles, setProfiles] = useState<BessProfile[]>(cache ?? []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await teslaApi.get("simulator/bess/profiles");
      cache = response.data as BessProfile[];
      setProfiles(cache);
    } catch {
      setError("Não foi possível carregar os perfis de consumo.");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!enabled || cache) return;
    load();
  }, [enabled, load]);

  return { profiles, loading, error, retry: load };
}
